import styled from 'styled-components';

// =====================================================
// MODERN FILTER PANEL STYLES
// Clean sidebar with organized sections
// =====================================================

export const FilterContGeneral = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;
  min-width: 280px;
  position: sticky;
  top: 24px;
`;

export const FilterCont = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const FilterTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
`;

export const ContListFilter = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

export const HeaderContListFilter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const BodyContListFilter = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const OneItemFilter = styled.li`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 0 -12px;
  border-radius: 8px;
  transition: background 0.15s ease;
  cursor: pointer;

  &:hover {
    background: #f8f7ff;
  }
`;

export const ContInputRadio = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;

  label {
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
    flex: 1;
  }
`;

// Modern Radio Button
export const InputRadio = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #7367f0;
    transition: transform 0.2s ease;
  }

  &:checked {
    border-color: #7367f0;
  }

  &:checked::after {
    transform: translate(-50%, -50%) scale(1);
  }

  &:hover:not(:checked):not(:disabled) {
    border-color: #7367f0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  & + label {
    margin: 0;
  }
`;

// Modern Checkbox
export const InputChecbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 5px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 5px;
    width: 5px;
    height: 9px;
    border: 2px solid white;
    border-top: none;
    border-left: none;
    transform: rotate(45deg) scale(0);
    transition: transform 0.2s ease;
  }

  &:checked {
    background: #7367f0;
    border-color: #7367f0;
  }

  &:checked::after {
    transform: rotate(45deg) scale(1);
  }

  &:hover:not(:checked):not(:disabled) {
    border-color: #7367f0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  & + label {
    margin: 0;
  }
`;

export const TwoItemFilter = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  border-radius: 10px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 8px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.3);
  }
`;

export const ContIconBtnfilter = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  background: white;
  border-radius: 6px;
  color: #7367f0;
  font-size: 14px;
`;

export const CurrentCategoryContent = styled.div`
  margin-top: 12px;
  padding: 12px;
  background: #f8f7ff;
  border-radius: 10px;
  border: 1px solid #e5e1ff;

  .row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .col {
    flex: 1;
    font-size: 13px;
    font-weight: 500;
    color: #7367f0;
    cursor: pointer;
  }

  .col-2 {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    color: #9ca3af;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: #ef4444;
    }
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Button = styled.button.attrs(props => ({
  variant: props.color || 'primary'
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;

  ${props => {
    switch (props.variant) {
      case 'danger':
        return `
          background: #fee2e2;
          color: #dc2626;
          &:hover:not(:disabled) { background: #fecaca; }
        `;
      case 'success':
        return `
          background: #dcfce7;
          color: #16a34a;
          &:hover:not(:disabled) { background: #bbf7d0; }
        `;
      case 'secondary':
        return `
          background: #f3f4f6;
          color: #374151;
          &:hover:not(:disabled) { background: #e5e7eb; }
        `;
      default:
        return `
          background: #7367f0;
          color: white;
          &:hover:not(:disabled) { background: #5a4fcf; }
        `;
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Section Label
export const SectionLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
`;